export function sanitizeText(input) {
  if (typeof input !== "string") return "";

  let text = input;

  // Normalize unicode (prevents hidden prompt injections)
  text = text.normalize("NFKC");

  // Remove zero-width & invisible characters
  text = text.replace(/[\u200B-\u200D\uFEFF]/g, "");

  // Decode basic HTML entities
  text = text
    .replace(/&nbsp;/gi, " ")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&amp;/gi, "&")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");

  // Remove HTML / XML tags
  text = text.replace(/<[^>]*>/g, "");

  // Remove markdown code blocks
  text = text.replace(/```[\s\S]*?```/g, "");

  // Remove inline code
  text = text.replace(/`[^`]*`/g, "");

  // Remove common prompt-injection phrases
  text = text.replace(
    /(ignore previous instructions|system prompt|you are chatgpt|act as|developer message)/gi,
    ""
  );

  // Remove role-like prefixes
  text = text.replace(/^(system|assistant|user|developer)\s*:/gim, "");

  // Collapse excessive whitespace
  text = text.replace(/\s+/g, " ").trim();

  return text;
}
